import 'sass/app.scss';

import _ from 'lodash';
import React from 'react';
import { Link } from 'react-router-dom';

const WelcomeMobile = () => {
    return (
        <div id="section-1" className="landing-bg-mobile">
            <div className="w-logo-mb"></div>
            <div className="welcome-btns-mb">
                <Link to="/artists-mobile" className="welcome-artists-mb">
                    <div>
                        <button className="big-button-mb">
                            Muzado for Artists
                        </button>
                        <div className={`popup-text shown`}>You know your worth, and so do we.</div>
                    </div>
                </Link>
                <Link to="/fans-mobile" className="welcome-fans-mb">
                    <div>
                        <button className="big-button-mb" style={{marginTop:'9vh'}}>
                            Muzado for Fans
                        </button>
                        <div className={`popup-text shown`}>The way music used to be, reimagined.</div>
                    </div>
                </Link>
            </div>
        </div>
    );
}
export class LandingSelectMobile extends React.Component {
	constructor (props) {
		super(props);
	}

	render() {
			// return <ArtistSignUpForm />;


		return (
			<div>
                <WelcomeMobile/>
            </div>
		);
	}
}

export default LandingSelectMobile;
